import SwipeSlider from './SwipeSlider';
export default SwipeSlider;
